import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function NotFound() {

    document.title = "Page not found";

    return (
        <Container>
            <h1><span>😰</span><br></br>404</h1>
            <h2>Oops that's embarrassing</h2>
            <h3>Seems like you're lost</h3>

            <Link to="/"><button>Go Home</button></Link>
        </Container >
    )
}

export default NotFound

const Container = styled.div`
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    h1 {
        padding-top: 30px;
        text-transform: uppercase;
        font-size: 68px;
    }

    h2 {
        text-transform: uppercase;
        font-size: 28px;
        padding-bottom: 10px;
    }

    h3 {
        text-transform: uppercase;
        padding-bottom: 20px;

        @media (max-width: 821px) {
            font-size: 16px;
        }
    }

    button {
      width: 200px;
      height: 50px;
      background-color: transparent;
      color: var(--primary);
      border: 2px solid var(--primary);
      text-transform: uppercase;
      font-weight: 600;
      font-size: 18px;


      :hover {
        background-color: var(--primary);
        color: #fff;
        transition: 0.2s ease-in;
      }
    }
`
